var jQ=jQuery.noConflict();